var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCustomers = function SvgCustomers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm1.93 10H8.07c.413-2.956 2.566-5 4.93-5s4.517 2.044 4.93 5ZM13 10c-3.023 0-5.524 2.609-5.94 6.002-.067.548.388.998.94.998h10c.552 0 1.007-.45.94-.998C18.523 12.61 16.023 10 13 10Zm-6.5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm-1.873 1.984a.5.5 0 1 0-.254-.968C2.516 12.504 1 14.486 1 16.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1H2.04c.222-1.396 1.333-2.687 2.587-3.016Z",
    clipRule: "evenodd"
  })));
};
export default SvgCustomers;